import moment from 'moment/moment';
import numeral from 'numeral';

export function joinAddress(location, additional = []) {
  return [
    ...additional,
    ...([
      'address1', 'address2', 'town', 'region', 'postcode', 'country'
    ].map(l => location[l]).filter(l => !!l)),
  ].join('\n');
}

export function currencySymbol(currency = 'GBP') {
  let symbol;
  switch (currency) {
    case 'EUR':
      symbol = '€';
      break;
    case 'GBP':
    default:
      symbol = '£';
      break;
  }
  return symbol;
}

export function formatCurrency(amount, currency = 'GBP') {
  return `${currencySymbol(currency)}${numeral(amount).format('0,0.00')}`;
}

export function saveDate(date) {
  return date ? moment(date).format('YYYY-MM-DD') : null;
}

export function firstLine(value) {
  if (value) {
    const split = value.split('\n');
    if (split.length > 0) {
      return split[0];
    }
  }
  return '-';
}

export function taskStatus(task) {
  return task.completed_at ? 'completed' : (moment(task.deadline).isBefore(moment().startOf('day')) ? 'overdue' : 'pending');
}

export function taskNextOccurrence(task) {
  const next = moment();
  switch (task.schedule?.value) {
    case 'weekly':
      next.add(1, 'week');
      break;
    case 'fortnightly':
      next.add(2, 'week');
      break;
    case 'monthly':
      next.add(1, 'month');
      break;
    case 'semi-annually':
      next.add(6, 'month');
      break;
    case 'annually':
      next.add(1, 'year');
      break;
    default:
      break;
  }
  return next.format('YYYY-MM-DD');
}